import { IPayment, MatchRemainingAction } from "../interface";

/**
 * @description - Get available payment id to focus
 * @param {IPayment[]} payments - payment list of data
 * @param {number | string} paymentId - paymentId of the payment that has to be focused
 * @return - Best suitable payment id to be focus
 */
export const getPaymentIdToFocus = (
  payments: IPayment[],
  paymentId: number | string
): number | undefined => {
  try {
    const paymentToFocus = payments.find(
      (payment: IPayment) => payment.paymentId == paymentId
    );
    if (paymentToFocus) {
      return paymentToFocus?.paymentId;
    } else {
      return payments[0].paymentId;
    }
  } catch (error) {
    return undefined;
  }
};

/**
 * @description - Get the latest offset value for the given payments count with the limit
 * @param {number} count - Current no of payments
 * @param {number} limit - Limit value
 * @return {number} - Next offset value
 */
export const calculateOffSet = (count: number, limit: number): number => {
  return Math.floor(count / limit) * limit;
};

/**
 * @description Checks if the account number has changed compared to the initial value.
 * @param {string} initialAccountNo - The initial account number from form values.
 * @param {string} currentAccountNo - The current account number from the input field.
 * @returns {boolean} - Returns true if the account number has changed, otherwise false.
 */
export const checkAccountNoChanged = (
  initialAccountNo: string, 
  currentAccountNo: string
): boolean => {
  try {
    const trimmedInitial = initialAccountNo.replace(/\s/g, '');
    const trimmedCurrent = currentAccountNo.replace(/\s/g, '');
    return ((trimmedInitial !== trimmedCurrent) && (trimmedCurrent !== ''));
  } catch (error) {
    return true;
  }
};

/**
 * @description - Get the remaining action based on the payment and the remaining balance
 * @param {any} payment - Payment record
 * @param {number} remainingBalance - Remaining balance to match
 */
export const getRemainingAction = (
  payment: any,
  remainingBalance: number
): MatchRemainingAction => {
  try {
    const { exceededSum, unknownSum } = payment;
    if (exceededSum > 0) {
      if (remainingBalance === exceededSum) {
        return MatchRemainingAction.RETURN_EXCEEDED;
      } else {
        return MatchRemainingAction.LEAVE_EXCEEDED;
      }
    } else if (unknownSum > 0) {
      if (remainingBalance === unknownSum) {
        return MatchRemainingAction.RETURN_EXCEEDED;
      } else {
        return MatchRemainingAction.LEAVE_EXCEEDED;
      }
    }
    return MatchRemainingAction.RETURN_EXCEEDED;
  } catch (error) {
    return MatchRemainingAction.RETURN_EXCEEDED;
  }
};
